const CallsContainerStyle = `
  grid-area: calls;
`;

export default CallsContainerStyle;
